var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { createAction, createReducer } from '@reduxjs/toolkit';
import * as statuses from 'services/store/states';
import * as types from './types';
import defaultEntity from 'constants/defaultEntity';
var initialState = {
    status: statuses.IDLE,
    entities: null,
};
var fetch = createAction(types.KYC_ENTITY_FETCH_REQUEST);
var fetchSuccess = createAction(types.KYC_ENTITY_FETCH_SUCCESS);
var fetchFail = createAction(types.KYC_ENTITY_FETCH_FAIL);
var addSociety = createAction(types.KYC_ENTITY_ADD_SOCIETY);
var updateSociety = createAction(types.KYC_ENTITY_UPDATE_SUCCESS);
var kycEntityReducer = createReducer(initialState, function (builder) {
    builder
        .addCase(fetch, function (state) { return (__assign(__assign({}, state), { status: statuses.LOADING })); })
        .addCase(fetchSuccess, function (state, action) { return (__assign(__assign({}, state), { status: statuses.SUCCESS, entities: action.payload })); })
        .addCase(fetchFail, function (state) { return (__assign(__assign({}, state), { status: statuses.FAIL })); })
        .addCase(addSociety, function (state, action) { return (__assign(__assign({}, state), { entities: __spreadArray(__spreadArray([], (state.entities || []), true), [action.payload], false) })); })
        .addCase(updateSociety, function (state, action) {
        var _a;
        return (__assign(__assign({}, state), { entities: ((!state.entities
                || (state.entities && state.entities.length === 0)) && action.payload)
                ? [
                    __assign(__assign({}, defaultEntity), action.payload),
                ]
                : (_a = (state.entities || [])) === null || _a === void 0 ? void 0 : _a.map(function (entity) {
                    if (entity.siren === action.payload.siren) {
                        return __assign(__assign({}, entity), action.payload);
                    }
                    return entity;
                }) }));
    });
});
export default kycEntityReducer;
